export default {
  name: 'NoMore',
  props: ['title']
};